<template>
    <div class="related-symptoms-section">
        <div class="main-symptom-top color-headings-text" >
            <h3 class="font-weight-regular  main-symptom-card-title">{{text('api.assessment.symptoms.mainSymptom')}}</h3>
            <div class="main-symptom color-primary">{{mainSymptom.name}}</div>
        </div>

        <div v-if="(relatedSymptomList.length > 0)"
             id="RELATED_SYMPTOMS"
             class="related-symptom-list-container concomitant-symptoms"
             :class="{'panel-highlighted': (isNavRelatedSymptomsAvailable && shortcutNav.isPanelHighlight)}"
             @click="onRelatedSymptomsPanelClick"
        >

            <h3 class="font-weight-regular font-size-small">{{text('db.product.PROD_TITLE_MSHA')}}</h3>

            <div v-for="symptom in relatedSymptomList" :id="'RELATED_S_' + symptom.code">
                <span v-if="mustShowCodes" class="font-size-small font-weight-light">
                    [{{ symptom.code }}]&nbsp;
                </span>
                <div class="symptom-name font-size-default font-weight-regular color-headings-text">{{ symptom.name }}</div>

                <div class="check-symptom">

                    <v-checkbox
                        :ref="'RELATED_SYMPTOM_' + symptom.code + '_YES'"
                        :id="'RELATED_S_CHECKBOX_YES_' + symptom.code"
                        :class="{'check-symptom-highlighted': (isNavRelatedSymptomsAvailable && shortcutNav.isPanelHighlight === false && shortcutNav.crtRelatedSymptom === symptom.code && shortcutNav.crtRelatedSymptomYes === true)}"
                        :label="text('api.label.yes')"
                        v-model="symptom.state"
                        :true-value="`${symptomStates.HAVE_SYMPTOM}`"
                        :false-value="`${symptomStates.NONE}`"
                        @change="handleChangeRelatedSymptomState(symptom.state, symptom.code)"
                        @click.native="onRelatedSymptomClick(symptom.code, true)"
                        class="yes-selected-symptom"
                        color="primary"
                        hide-details
                    ></v-checkbox>

                    <v-checkbox
                        :ref="'RELATED_SYMPTOM_' + symptom.code + '_NO'"
                        :id="'RELATED_S_CHECKBOX_NO_' + symptom.code"
                        :class="{'check-symptom-highlighted': (isNavRelatedSymptomsAvailable && shortcutNav.isPanelHighlight === false && shortcutNav.crtRelatedSymptom === symptom.code && shortcutNav.crtRelatedSymptomYes === false)}"
                        :label="text('api.label.no')"
                        v-model="symptom.state"
                        :true-value="`${symptomStates.NOT_HAVE_SYMPTOM}`"
                        :false-value="`${symptomStates.NONE}`"
                        @change="handleChangeRelatedSymptomState(symptom.state, symptom.code)"
                        @click.native="onRelatedSymptomClick(symptom.code, false)"
                        class="no-selected-symptom"
                        hide-details
                    ></v-checkbox>

                </div>

            </div>
        </div>

        <div  v-if="noOtherSymptomsCheck"
              id="NO_OTHER_SYMPTOMS"
              class="no-other-symptoms-section"
              :class="{'panel-highlighted': (shortcutNav.isKeyboardNav === true && shortcutNav.isPanelHighlight === true && shortcutNav.crtPanel === 'NO_OTHER_SYMPTOMS')}"
              @click="onNoOtherSymptomsPanelClick"
        >
            <v-checkbox ref="noOtherSymptomsRef"
                        id="NO_OTHER_SYMPTOMS_CHECKBOX"
                        class="no-other-symptoms"
                        :class="{'checkbox-highlighted': shortcutNav.isKeyboardNav === true && shortcutNav.isPanelHighlight === false && shortcutNav.crtPanel === 'NO_OTHER_SYMPTOMS'}"
                        v-model="noOtherSymptoms"
                        @change="handleNoOtherSymptomsState(noOtherSymptoms)"
                        :ripple="false"
            >
            </v-checkbox>
            <span>{{text('db.product.PROD_PROPERTY_NO_OTHER_SYMPTOMS_CONFIRMATION')}}</span>
        </div>
    </div>
</template>

<!-- ################################################################## -->

<script>
    import {mapGetters} from 'vuex';
    import axios from 'axios/dist/axios';
    import Vue from "vue"; // need this to use the plugin methods

    export default {
        name: 'RelatedSymptoms',

        props: ["shortcutNav"],

        data() {
          return {
              noOther: false,
              checkBoxPlugin: Vue.CheckBox.checkBoxSvg
          }
        },
        computed: {
            ...mapGetters({
                relatedSymptomList: 'SymptomsQuestionsStore/getRelatedSymptomList',
                symptomStates: 'SymptomsQuestionsStore/getRelatedSymptomStates',
                isAdmin: 'UserStore/getIsAdmin',
                mustShowCodes: 'UserStore/getDebugMustShowCodes',
                mustShowFullQuestion: 'SymptomsQuestionsStore/getMustShowFullQuestion',
                isFooterNextBtnEnabled: 'SymptomsQuestionsStore/getIsFooterNextBtnEnabled',
                selectedRelatedSymptomList: 'SymptomsQuestionsStore/getSelectedRelatedSymptomList',
                mainSymptom: 'SymptomsQuestionsStore/getMainSymptom',
                noOtherSymptomsCheck: 'SymptomsQuestionsStore/getNoOtherSymptomsCheck',
                getAppPropertyValue: 'TranslationStore/getAppPropertyValue',
                mustShowVitalParametersForm: 'VitalParametersStore/getMustShowVitalParamsForm',
            }),

            noOtherSymptoms: {
                get() {
                    return this.$store.getters['SymptomsQuestionsStore/getNoOtherSymptoms'];
                },
                set(newVal) {
                    this.$store.commit('SymptomsQuestionsStore/setNoOtherSymptoms', newVal);
                },
            },

            isNavRelatedSymptomsAvailable() {
                return this.shortcutNav != null && this.shortcutNav.isKeyboardNav === true && this.shortcutNav.crtPanel === 'RELATED_SYMPTOMS';
            }

        },

        methods: {

            handleChangeRelatedSymptomState(newStateValue, symptomCode) {
                // For the "yes" answer if the VitalParametersForm is opened we do nothing to prevent the Enter event handler
                if (this.mustShowVitalParametersForm === true) {
                    return;
                }

                this.$store.dispatch("SymptomsQuestionsStore/handleChangeRelatedSymptomState", {
                    newSymptomState: newStateValue,
                    symptomCode: symptomCode
                });
                if(newStateValue === 'HAVE_SYMPTOM'){
                    let that = this;
                    setTimeout(function(){

                        let selectedInput = document.getElementsByClassName('yes-selected-symptom');
                        for (let i = 0; i < selectedInput.length; i++) {


                            let selectedInputIcon = selectedInput[i].getElementsByClassName('icon--checkbox');

                            for (let j = 0; j < selectedInputIcon.length; j++) {

                                selectedInputIcon[j].innerHTML = that.checkBoxPlugin();
                            }

                        }

                    },10)
                }

            },

            handleNoOtherSymptomsState(noOtherSymptoms) {
                if (this.mustShowVitalParametersForm === true) {
                    return;
                }

                axios.post(process.env.API_BASE_URL + '/assessment/noOtherSymptoms', {
                    value: noOtherSymptoms
                });
            },

            getCheckboxObj() {

                let vCheckboxObjArr;
                if (this.shortcutNav.crtRelatedSymptomYes) {
                    vCheckboxObjArr = this.$refs['RELATED_SYMPTOM_' + this.shortcutNav.crtRelatedSymptom + '_YES'];
                }
                else {
                    vCheckboxObjArr = this.$refs['RELATED_SYMPTOM_' + this.shortcutNav.crtRelatedSymptom + '_NO'];
                }

                if (typeof vCheckboxObjArr !== "undefined" && typeof vCheckboxObjArr[0] !== "undefined") {
                    return vCheckboxObjArr[0];
                }

                return vCheckboxObjArr;
            },

            onRelatedSymptomClick(symptomCode, symptomYes) {
                this.$emit('emitRelatedSymptomClick', {
                    symptomCode: symptomCode,
                    symptomYes: symptomYes
                });

            },

            onRelatedSymptomsPanelClick() {
                this.$emit('emitRelatedSymptomsPanelClick');
            },

            onNoOtherSymptomsPanelClick() {
                this.$emit('emitNoOtherSymptomsPanelClick');

              //  }
            },
            afterLoad() {
                let that = this;
                setTimeout(function(){

                    let selectedInput = document.getElementsByClassName('yes-selected-symptom');
                    for (let i = 0; i < selectedInput.length; i++) {


                        let selectedInputIcon = selectedInput[i].getElementsByClassName('icon--checkbox');

                        for (let j = 0; j < selectedInputIcon.length; j++) {

                            selectedInputIcon[j].innerHTML = that.checkBoxPlugin();
                        }

                    };

                    let noOtherSymptom = document.getElementsByClassName('no-other-symptoms-section');
                    for(let i = 0; i < noOtherSymptom.length; i++) {
                        let iconCheckBox = noOtherSymptom[i].getElementsByClassName('icon--checkbox');

                        for(let j =0; j < iconCheckBox.length; j++) {
                            iconCheckBox[j].innerHTML = that.checkBoxPlugin();
                        }
                    }

                },1000)
            }

        },
        watch: {
            relatedSymptomList(newVal, oldVal) {

                if(newVal) {
                    let that = this;
                    setTimeout(function(){
                        let selectedInput = document.getElementsByClassName('yes-selected-symptom');
                        for (let i = 0; i < selectedInput.length; i++) {


                            let selectedInputIcon = selectedInput[i].getElementsByClassName('icon--checkbox');

                            for (let j = 0; j < selectedInputIcon.length; j++) {

                                selectedInputIcon[j].innerHTML = that.checkBoxPlugin();
                            }

                        }

                    },10)

                }
            },
            noOtherSymptoms(newVal, oldValue) {
                if(newVal) {
                        let that =this;
                    setTimeout(function(){
                        let noOtherSymptom = document.getElementsByClassName('no-other-symptoms-section');
                        for(let i = 0; i < noOtherSymptom.length; i++) {
                            let iconCheckBox = noOtherSymptom[i].getElementsByClassName('icon--checkbox');

                            for(let j =0; j < iconCheckBox.length; j++) {
                                iconCheckBox[j].innerHTML = that.checkBoxPlugin();
                            }
                        }

                    },10)

                }
            },
            mustShowVitalParametersForm(newValue) {
                if (this.shortcutNav.crtRelatedSymptom != null && this.shortcutNav.crtPanel != null) {
                    // When opening the VitalParametersForm with keyboard navigation while using keyboard navigation to answer yes or no to the related symptoms checkboxes
                    // we need to blur the "NO" checkbox to avoid responding to this checkbox while trying to edit an input field in the VitalParametersForm
                    if (this.shortcutNav.crtPanel === 'RELATED_SYMPTOMS' && this.shortcutNav.crtRelatedSymptomYes === false) {
                        // Opening the VitalParametersForm
                        if (newValue === true) {
                            this.$refs['RELATED_SYMPTOM_' + this.shortcutNav.crtRelatedSymptom + '_NO'][0].$el.blur();
                        }
                        // Closing the VitalParametersForm
                        else {
                            this.$refs['RELATED_SYMPTOM_' + this.shortcutNav.crtRelatedSymptom + '_NO'][0].$el.focus();
                        }
                    }
                    if (this.shortcutNav.crtPanel === 'NO_OTHER_SYMPTOMS') {
                        if (newValue === true) {
                            this.$refs['noOtherSymptomsRef'].$el.blur();
                        }
                        else {
                            this.$refs['noOtherSymptomsRef'].$el.focus();
                        }
                    }
                }
            }
        },
        mounted() {
            this.afterLoad();
        }

    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>


    h3 {
        color: $color-headings-text;
    }

</style>



// WEBPACK FOOTER //
// src/professional/components/symptoms-questions/RelatedSymptoms.vue